import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { toUnit } from '@/utils/styles'
import { DefaultButtonBar } from '@/components/button-bar'
import PageTitle from '@/components/page-title'
import { breakpoints, colors, fontSizes, structure } from '@/styles'

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: calc(100vh - ${toUnit(structure.button_bar.height)} - ${toUnit(structure.header.height)});

  @media screen and (max-width: ${breakpoints.ipadMiniMax}) {
    height: calc(
      100vh - ${toUnit(structure.button_bar.height)} - ${toUnit(structure.header.heightMobile)}
    );
  }
`

const Description = styled.p`
  font-size: ${fontSizes.regular};
  color: ${colors.regular};
`

const Invalid: React.VoidFunctionComponent<{ noSubtitle: boolean }> = ({ noSubtitle }) => {
  const { t } = useTranslation()

  return (
    <>
      {!noSubtitle && (
        <PageTitle>{t('b.contract.view.invalid_contract.title', 'Invalid Contract')}</PageTitle>
      )}
      <Content>
        <Description>
          {t(
            'b.contract.view.invalid_contract_description.text',
            'This contract is no longer available.'
          )}
        </Description>
      </Content>
      <DefaultButtonBar />
    </>
  )
}

export default Invalid
